export enum BulkOrderStageEnum {
  TEMPLATE = "TEMPLATE",
  PARAMS = "PARAMS",
  STATUS = "STATUS",
}
